import {registerJQueryComponent} from '@lib/JQueryRegistry'
import LoginFormField from './LoginFormField';

export default class LoginInputFormField extends LoginFormField {
    constructor(rootElement) {
        super(rootElement);
        this.duringInitialization = true
        this.$dom.input = rootElement.find('input');
        this.$dom.root.keyup(this.onKeyUp)
        this.onKeyUp()
        this.duringInitialization = false
    }

    onKeyUp = e => {
        this.$state.isInputFilled = ((this.$dom.input.val() || []).length > 0)

        // Ignore TAB.
        if ((e && e.which !== 9) || !e) {
            if (this.duringInitialization === false || this.$state.isInputFilled) {
                this.validate();
            }
        }
    }

    isValid() {
        if (this.$dom.input.attr('type') === 'email') {
            let val = this.$dom.input.val()
            let exp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
            return typeof val === 'string' && exp.test(val);
        }

        var input = this.$dom.input[0];
        if (input && input.name === 'ConfirmPassword') {
            var password = $('input[name="Password"]').val();
            if (this.$dom.input.val() !== password) {
                return false;
            }
        }

        if (input && input.name === 'Password') {
            var confirmPassword = $('input[name="ConfirmPassword"]')
            if (this.$dom.input.val() === confirmPassword.val()) {
                $('input[name="ConfirmPassword"]').closest('.login-form-field').find('.login-form-field-status').removeClass('invalid').addClass('valid');
            }
        }

        return this.$state.isInputFilled
    }
}

registerJQueryComponent(LoginInputFormField, '.login-form-field-input')